import clsx from 'clsx';
import { initialOf, colorFor } from '../shared/format.js';

const sizeMap = {
  sm: 'w-8 h-8 text-[13px]',
  md: 'w-[42px] h-[42px] text-base',
  lg: 'w-16 h-16 text-2xl',
  xl: 'w-[88px] h-[88px] text-[34px]'
};

function shade(hex, amount) {
  const c = hex.replace('#', '');
  const n = parseInt(c, 16);
  let r = (n >> 16) + amount;
  let g = ((n >> 8) & 0xff) + amount;
  let b = (n & 0xff) + amount;
  r = Math.max(0, Math.min(255, r));
  g = Math.max(0, Math.min(255, g));
  b = Math.max(0, Math.min(255, b));
  return '#' + (r * 65536 + g * 256 + b).toString(16).padStart(6, '0');
}

export function Avatar({ name = '?', id, size = 'md', src, className = '' }) {
  const color = colorFor(id || name);
  const initial = initialOf(name);
  const cls = clsx('grid place-items-center rounded-full text-white font-bold flex-none', sizeMap[size] || sizeMap.md, className);

  if (src) {
    return <img src={src} alt={name} className={clsx(cls, 'object-cover')} />;
  }

  return (
    <div
      className={cls}
      style={{ background: `linear-gradient(135deg, ${color}, ${shade(color, -15)})` }}
    >
      {initial}
    </div>
  );
}
